import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';

import { SegmentedControl } from '@treams/treams-ui';

export default function LearningExploreViewToggle() {
	const { t } = useTranslation();
	const history = useHistory();
	const location = useLocation();
	const isCalendar = location.pathname.startsWith('/learning/calendar');

	return (
		<SegmentedControl
			value={isCalendar ? 'calendar' : 'list'}
			options={[
				{ title: t('learning.events.navigation.listView'), value: 'list' },
				{ title: t('learning.events.navigation.calendarView'), value: 'calendar' },
			]}
			onChange={(value) => {
				history.push(value === 'calendar' ? '/learning/calendar' : '/learning');
			}}
		/>
	);
}
